import { Injectable } from '@angular/core';
import { ApiCallHandler, EoHttpClient, IDataService, IHttpParams, PaginatedSearchResult } from 'ngx-eo-web-components';
import { CoreService } from '../../modules/core/core.service';
import { Clinic } from '../../modules/core/models/clinic.model';
import { Observable } from 'rxjs';
import { ISortParams } from '../../modules/shared/models/sort.model';
import { ClinicPub } from '../../modules/core/models/clinic-pub.model';
import { ClinicGroup } from '../../modules/core/models/clinic-group.model';

@Injectable({
  providedIn: 'root',
})
export class ClinicService implements IDataService<ClinicPub> {

  constructor(private http: EoHttpClient, private coreService: CoreService) {}
  public searchCh = new ApiCallHandler<PaginatedSearchResult<ClinicPub> | null>();

  public clinicListCallHandler = new ApiCallHandler<ClinicPub[]>();
  public clinicGroupListCallHandler = new ApiCallHandler<ClinicGroup[]>();

  public clinicListByHospitalCallHandler = new ApiCallHandler<Clinic[]>();

  public clinicFetchCallHandler = new ApiCallHandler<ClinicPub>();

  public clinicSaveCallHandler  =  new ApiCallHandler<Clinic | null>();
  public clinicUpdateCallHandler  =  new ApiCallHandler<Clinic | null>();
  public clinicDeleteCallHandler  =  new ApiCallHandler<Clinic | null>();


  init() {
    this.clinicListCallHandler.init([]);
    this.clinicGroupListCallHandler.init([]);
    this.clinicListByHospitalCallHandler.init([]);

    this.clinicFetchCallHandler.init();
    this.clinicSaveCallHandler.init(null);
    this.clinicUpdateCallHandler.init(null);
    this.clinicDeleteCallHandler.init(null);
    this.searchCh.init();
  }

  getAllClinics() {
    const param: IHttpParams = this.coreService.initCall(
      `/v1/Clinics/list`,
      this.clinicListCallHandler
    );

    return this.http.get<ClinicPub[]>(param);
  }

  getPrivateClinicsGrouped() {
    const param: IHttpParams = this.coreService.initCall(
      `/v1/Clinics/private/grouped`,
      this.clinicGroupListCallHandler
    );

    return this.http.get<ClinicGroup[]>(param);
  }

  getClinicsByHospitalId(hospitalId:string) {
    const param: IHttpParams = this.coreService.initCall(
      `/v1/Clinics/list/${hospitalId}`,
      this.clinicListByHospitalCallHandler
    );

    return this.http.get<Clinic[]>(param);
  }

  getClinicById(clinicId:string) {
    const param: IHttpParams = this.coreService.initCall(
      `/v1/Clinics/fetch/${clinicId}`,
      this.clinicFetchCallHandler
    );

    return this.http.get<Clinic>(param);
  }

  searchClinics(
    searchParams: {
      HospitalID: string | null;
      SortParams: ISortParams | null;
    } = { HospitalID: null, SortParams: null },
    pagesize: number,
    page: number
  ): Observable<PaginatedSearchResult<ClinicPub>> {
    const param: IHttpParams = this.coreService.initCall(
      `/v1/Clinics/search/${pagesize}/${page}`,
      this.searchCh,
      searchParams
    );

    return this.http.post<PaginatedSearchResult<ClinicPub>>(param);
  }

  saveClinic(clinic: Clinic) {
    const param: IHttpParams = this.coreService.initCall(
      '/v1/Clinics/save',
      this.clinicSaveCallHandler,
      clinic
    );
    return this.http.post(param);
  }

  updateClinic(clinic: Clinic) {
    const param: IHttpParams = this.coreService.initCall(
      '/v1/Clinics/update',
      this.clinicUpdateCallHandler,
      clinic
    );
    return this.http.put(param);
  }

  deleteClinic(clinicId:string) {
    const param: IHttpParams = this.coreService.initCall(
      `/v1/Clinics/delete/${clinicId}`,
      this.clinicDeleteCallHandler
    );
    return this.http.delete(param);
  }
}
